import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns isCompanyStore boolean from page state
 */
export default function useIsCompanyStore(): boolean {
    return useAppSelector((state) => state?.page.isCompanyStore)
}